import React from 'react';
import {ApolloClient, ApolloProvider, createHttpLink, InMemoryCache} from '@apollo/client';
import Cookies from 'universal-cookie';

const httpLink = createHttpLink({
    uri: window.API_URL,
    fetch: (uri, options) => {
        const cookies = new Cookies();
        const token = cookies.get('token');
        if (typeof token !== 'undefined') {
            options.headers['Authorization'] = `Bearer ${token}`;
        }
        return fetch(uri, options);
    },
});

const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({
        typePolicies: {
            // CreditPagination: {
            //     keyFields: false,
            // },
            // CustomerIbanPagination: {
            //     keyFields: false,
            // },
            // DepositPagination: {
            //     keyFields: false,
            // },
            ProjectPagination: {
                keyFields: false,
            },
            StagePagination: {
                keyFields: false,
            },
            OrderDocumentPagination: {
                keyFields: false,
            },
            StageDividendPayoutPagination: {
                keyFields: false,
            },
            StageInterestPayoutPagination: {
                keyFields: false,
            },
            // WithdrawalRequestPagination: {
            //     keyFields: false,
            // },
            StageBuyToLet: {
                keyFields: false,
            },
            StageBuyToSell: {
                keyFields: false,
            },
            StageLoan: {
                keyFields: false,
            },
            PayoutSchedule: {
                fields: {
                    payments: {
                        merge(existing = [], incoming = []) {
                            return incoming;
                        },
                    }
                }
            }
        }
    }),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'network-only'
        },
        query: {
            fetchPolicy: 'network-only'
        }
    }
});

export default ({children}) => (
    <ApolloProvider client={client}>
        {children}
    </ApolloProvider>
);
